module.exports = __webpack_public_path__ + "media/images/technology/medal-icon-3248cf23cee732d5b5b0d4b1523ce02b.png";